var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('button',{staticClass:"support-button",attrs:{"title":_vm.$tc('layout.header.support')},on:{"click":_vm.openModal}},[_c('i',{staticClass:"icon icon-help"})]),(_vm.showModal)?_c('SupportModal',{attrs:{"formData":_vm.formData},on:{"close":_vm.closeModal,"update:formData":_vm.updateFormData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }